import * as requestFromServer from "./ContentCrud";
import { contentSlice, callTypes } from "./ContentSlice";
import { toast } from "react-hot-toast";
import { AppDispatch } from "../store";

const { actions } = contentSlice;

export const getAllContent = (data?: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    })
  );
  return requestFromServer
    .getAllContent(data)
    .then((response) => {
      dispatch(
        actions.getAllContent({
          allContent: response?.data?.data.results,
          page: response?.data?.data?.page,
          total: response?.data?.data?.totalCount,
          size: response?.data?.data?.limit,
        })
      );
    })
    .catch((error) => {
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
          errorType: "emailNotSent",
        })
      );
      toast.error(error?.response?.data?.message);
    });
};

export const getContentById = (data?: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    })
  );
  return requestFromServer
    .getContentById(data)
    .then((response) => {
      dispatch(
        actions.getContentById({
          contentToEdit: response?.data?.content,
        })
      );
    })
    .catch((error) => {
      error.clientMessage = error.message;

      // toast.error(error?.response?.data?.message);
    });
};
export const updateContentById = (id: string, data?: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    })
  );
  return requestFromServer
    .updateContentById(id, data)
    .then((response) => {
      dispatch(
        actions.updateContentById({
          contentForEdit: response?.data,
        })
      );
      data?.type === "help"
        ? toast.success(data?.isDeleted ? "Deleted Successfully" : data?.isEditCase ? "Updated Successfully" : "Created successfully")
        : toast.success(data?.isActive ? "Published Successfully" : "Created successfully");
    })
    .catch((error) => {
      error.clientMessage = error.message;

      // toast.error(error?.response?.data?.message);
    });
};
export const createHelpContent = (data: any, navigate: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    })
  );
  return requestFromServer
    .createHelpContent(data)
    .then((response) => {
      if (response?.data?.data?._id) {
        navigate(`/content/help/${response?.data?.data?.helpContent?.pageName}/${response?.data?.data?._id}`);
      }
    })
    .catch((error) => {
      error.clientMessage = error.message;
    });
};

export const getAllContentLogs = (data?: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    })
  );
  return requestFromServer
    .getAllContentLogs(data)
    .then((response) => {
      dispatch(
        actions.getAllContentLogs({
          logs: response?.data?.allLogs,
          total: response?.data?.totalCount,
        })
      );
    })
    .catch((error) => {
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
          errorType: "emailNotSent",
        })
      );
      toast.error(error?.response?.data?.message);
    });
};

export const setSelectedModule = (module: any) => (dispatch: AppDispatch | any) => {
  dispatch(actions.setSelectedModule(module));
};
